import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'AnalyticalAxis';
const ENDPOINT = `/analytical-axes/`;

@Injectable({
    providedIn: 'root'
})
export class AnalyticalAxisService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
